import React from "react";
import "./Css/Awards.css";
import awardImg from "./Images/awards.jpg"; 
import awardImg1 from "./Images/Pusakar2.jpg";

export default function AwardsSection() {
  const awards = [
        { year: "२००९", title: "संत गाडगेबाबा निर्मल ग्राम पुरस्कार", image: awardImg1 },
    { year: "२०११", title: "निर्मल ग्राम पुरस्कार", image: awardImg },
  ];

  return (
    <section className="awards-section">
      <h2 className="awards-title"> पुरस्कार आणि सन्मान </h2>
      <p className="awards-subtitle">
        आमच्या गावाच्या उत्कृष्टतेची आणि प्रगतीची गाथा
      </p>

      <div className="awards-container">
        {awards.map((award, index) => (
          <div key={index} className="award-card">
            <img src={award.image} alt={award.title} className="award-image" />
            <div className="award-info">
              <span className="award-year">{award.year}</span>
              <h3 className="award-name">{award.title}</h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
